import PropTypes from 'prop-types';

import { useScreenSizeContext } from '@/components/ScreenSize.context';

export const HeaderPromotionEspot = ({ espot: { htmlContent, htmlContentMobile } = {} }) => {
  const isMobile = useScreenSizeContext().isMobile;
  const innerHtml = (isMobile && htmlContentMobile) ? htmlContentMobile : htmlContent;

  return innerHtml ? (
    <div className="espot-html" dangerouslySetInnerHTML={{ __html: innerHtml }} data-test-id="espot-html" data-rbf="espot-html"/>
  ) : null;
};

HeaderPromotionEspot.propTypes = {
  espot: PropTypes.object.isRequired,
};

export default HeaderPromotionEspot;
